module.exports = __webpack_public_path__ + "img/hover_icon_cumplimiento_rlv.5a24a1b8.svg";